/**
 * ScanYearOldDto object
 */
export class ScanYearOldDto {
  faceNumber: number;
  gender: string;
  ageRange: string;
  localTime?: any;
}